<mat-toolbar class="mat-elevation-z4">
    <button
      mat-icon-button
      (click)="drawer.toggle()"
      aria-label="Icone menu"
      class="mat-toolbar"
    >
      <mat-icon>menu</mat-icon>
    </button>
  <div class="img-logo">
    <a href="https://www2.unesp.br" target="_blank"><img
      src="header/logo.svg"
      alt="Universidade Estadual Paulista JÃºlio de Mesquita Filho" class="img-logo-tamanho"/>
    </a>
  </div>
  <div class="app-title"><a href="https://www2.unesp.br/portal#!/cdep3" target="_blank"><img src="assets/img/logo-cdep3.png" alt="Logo CDeP3" class="nav-logo"></a></div>
</mat-toolbar>

<mat-drawer-container class="container" autosize>
  <mat-drawer #drawer class="sidenav" mode="side" [opened]="true">
    <mat-nav-list class="nav-list">
      @if (authService.isAuthenticated()) {
        <a mat-list-item class="list-item" routerLink="ava-unesp">
          <mat-icon mat-list-icon class="list-icon">school</mat-icon>
          <span>AVA UNESP</span>
        </a>
        <a mat-list-item class="list-item" routerLink="/meu-perfil">
          <mat-icon mat-list-icon class="list-icon">person</mat-icon>
          <span>Perfil</span>
        </a>
        <a mat-list-item class="list-item" routerLink="alterar-senha">
          <mat-icon mat-list-icon class="list-icon">lock</mat-icon>
          <span>Alterar Senha</span>
        </a>
        <a mat-list-item class="list-item" routerLink="meus-documentos">
          <mat-icon mat-list-icon class="list-icon">picture_as_pdf</mat-icon>
          <span>Meus Documentos</span>
        </a>
        <a mat-list-item class="list-item"  (click)="logout()">
          <mat-icon mat-list-icon class="list-icon">logout</mat-icon>
          <span>Sair</span>
        </a>
      }
      <mat-divider></mat-divider>
      <a mat-list-item class="list-item" routerLink="consulta-documento">
        <mat-icon mat-list-icon class="list-icon">qr_code_scanner</mat-icon>
        <span>Autenticidade do Documento</span>
      </a>
      @if (!authService.isAuthenticated()) {
        <mat-divider></mat-divider>
        <a mat-list-item class="list-item" routerLink="login">
          <mat-icon mat-list-icon class="list-icon">login</mat-icon>
          <span>Login</span>
        </a>
      }
    </mat-nav-list>
  </mat-drawer>

  <div class="sidenav-content">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
